import LoopStatus from "./Status";

export default {
  updateLoopStatus({ dispatch }, { loop, status }) {
    dispatch("setLoop", { loop: LoopStatus.update(loop, status) });
  }
};
